import React, { Component } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

class Filter extends Component {
  constructor (props) {
    super(props)
    this.state = {
      active: -1
    }

    this.setActiveFilter = this.setActiveFilter.bind(this)
  }

  setActiveFilter (id, filter) {
    this.setState({ active: id })
    this.props.onFilterChange(filter)
  }

  render () {
    // Sort the filter keys
    let filters = []
    Object.keys(this.props.filters).forEach(key => {
      filters.push(this.props.filters[key])
    })
    filters = filters.sort((a, b) => {
      if (a.name < b.name) return -1
      if (a.name > b.name) return 1
      return 0
    })

    const filterNodes = filters.map((filter, idx) => (
      <FilterNode
        key={idx}
        label={filter.name}
        count={filter.count}
        onClick={() => this.setActiveFilter(filter.id, filter)}
        className={classnames({
          'active': filter.id === this.state.active
        })}
      />
    ))

    return (
      <ul className='grid-filter'>
        { filterNodes }
      </ul>
    )
  }
}

const FilterNode = (props) => (
  <li className={props.className}>
    <span onClick={props.onClick}>
      {props.label}
      <sup>{props.count}</sup>
    </span>
  </li>
)

Filter.propTypes = {
  filters: PropTypes.object.isRequired
}

export default Filter



// WEBPACK FOOTER //
// ./src/components/Grid/Filter/index.js